// Campo.js
import React, { useState } from 'react';
import "./CreaEvento.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const Campo = ({
  nome,
  descrizione,
  traduzioni = [],
  lingue = [],
  onChange,
  onTraduzioneChange,
  onRemove,
}) => {
  const [espanso, setEspanso] = useState(false);

  const getTraduzione = (codice) =>
    traduzioni.find((t) => t.codiceLingua === codice) || { codiceLingua: codice, nome: '', descrizione: '' };

  return (
    <div>
      <div className='portate'>
        <label>
          Nome:
          <input type="text" name="nome" value={nome} onChange={onChange} />
        </label>

        <label>
          Descrizione:
          <input type="text" name="descrizione" value={descrizione} onChange={onChange} />
        </label>

        <button type="button" onClick={onRemove}>
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>

      {lingue.length > 0 && (
        <div style={{ margin: '5px 0 10px 0' }}>
          <button
            type="button"
            onClick={() => setEspanso(!espanso)}
            style={{ background: 'none', color: '#333', padding: '4px 8px', fontSize: '13px' }}
          >
            <FontAwesomeIcon icon={espanso ? faChevronDown : faChevronRight} />
            {' '}Traduzioni ({lingue.length})
          </button>

          {espanso && (
            <div style={{ padding: '8px 12px', borderLeft: '3px solid #ddd', marginTop: '5px' }}>
              <small style={{ color: '#666' }}>
                Lascia vuoto per traduzione automatica al salvataggio.
              </small>
              {lingue.map((lingua) => {
                const t = getTraduzione(lingua.codice);
                return (
                  <div key={lingua.codice} style={{ marginTop: '8px' }}>
                    <strong style={{ fontSize: '13px' }}>{lingua.descrizione}</strong>
                    <div className='portate'>
                      <label>
                        Nome:
                        <input
                          type="text"
                          value={t.nome}
                          placeholder="Traduzione automatica"
                          onChange={(e) => onTraduzioneChange(lingua.codice, 'nome', e.target.value)}
                        />
                      </label>
                      <label>
                        Descrizione:
                        <input
                          type="text"
                          value={t.descrizione}
                          placeholder="Traduzione automatica"
                          onChange={(e) => onTraduzioneChange(lingua.codice, 'descrizione', e.target.value)}
                        />
                      </label>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
      <hr />
    </div>
  );
};

export default Campo;
